/* Debounce Function in order to limit function calls  */
export function debounce(f, ms) {

    let isCooldown = false;

    return function() {
        if (isCooldown) return;

        f.apply(this, arguments);

        isCooldown = true;

        setTimeout(() => isCooldown = false, ms);
    };
}

/* Throttle Function in order to limit function calls  */
export function throttle(func, ms) {

    let isThrottled = false,
        savedArgs,
        savedThis;

    function wrapper() {

        if (isThrottled) { // (2)
            savedArgs = arguments;
            savedThis = this;
            return;
        }

        func.apply(this, arguments); // (1)

        isThrottled = true;

        setTimeout(function() {
            isThrottled = false; // (3)
            if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
            }
        }, ms);
    }

    return wrapper;
}

/* Get time string by provided timestamp and delimiter */
export function getTimeByTimestamp(timestamp, delimiter = ':') {
    const date = new Date(timestamp);
    const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
    return `${hours}${delimiter}${minutes}${delimiter}${seconds}`;
}

/* Declension of words by number */
export function declension(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5]];
}

export function removeHash () {
    history.replaceState("", document.title, window.location.pathname
        + window.location.search);
}

export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

export function toNumberRange(range) {
    return range.split('-').map(Number);
}

export function rangesIntersection(a, b) {
    //get the range with the smaller starting point (min) and greater start (max)
    const min = (a[0] < b[0]  ? a : b);
    const max = (min === a ? b : a);

    //min ends before max starts -> no intersection
    return min[1] < max[0] ? false : [max[0] , (min[1] < max[1] ? min[1] : max[1])];
}

export function comprehensiveRange(...args) {
    const min = args.map((range) => range[0]);
    const max = args.map((range) => range[1]);
    return [Math.min(...min), Math.max(...max)];
}